import axios from "axios";

const baseUrl = process.env.REACT_APP_BE_URL || "http://localhost:5002";

const axiosInstance = axios.create({
  baseURL: baseUrl,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use((config) => {
  try {
    const token = JSON.parse(localStorage.getItem('userInfo'))?.token;
    if (token) config.headers.Authorization = `Bearer ${token}`;
  } catch (err) {
    // ignore
  }
  return config;
});

export default axiosInstance;
